import { combineReducers } from "redux"
import loginReducer from "../login/loginReducer"
import tenantReducer from "../tenants/tenantReducer"
const RootReducer = combineReducers({
 login: loginReducer,
  tenant: tenantReducer
})

export default RootReducer